import React, {useEffect, useState} from 'react';

import {CheckIcon, SmallLoader, WarningTriangleIcon} from '@kit';

import {cls} from '../../../components/utils';
import {useCharacter} from './character-context';

import css from './character-page.module.css';

const SAVED_VISIBLE = 1500;

/** значок сохранения в углу экрана: крутится, пока изменения не дошли до сервера */
export const SaveIndicator: React.FC = () => {
	const {saveStatus} = useCharacter();
	const [isSavedVisible, setSavedVisible] = useState(false);

	useEffect(() => {
		if (saveStatus !== 'saved') return;
		setSavedVisible(true);
		const timer = setTimeout(() => setSavedVisible(false), SAVED_VISIBLE);
		return () => clearTimeout(timer);
	}, [saveStatus]);

	const isSaving = saveStatus === 'pending' || saveStatus === 'saving';
	const isError = saveStatus === 'error';
	const isVisible = isSaving || isError || (saveStatus === 'saved' && isSavedVisible);

	return (
		<div
			className={cls(css.saveIndicator, isVisible && css.saveIndicatorVisible, isError && css.saveIndicatorError)}
			role="status"
			aria-live="polite"
		>
			{isSaving && (
				<>
					<span className={css.saveIndicatorIcon}>
						<SmallLoader />
					</span>
					Сохранение…
				</>
			)}
			{saveStatus === 'saved' && (
				<>
					<CheckIcon className={css.saveIndicatorIcon} />
					Сохранено
				</>
			)}
			{isError && (
				<>
					<WarningTriangleIcon className={css.saveIndicatorIcon} />
					Не сохранено, повторим при следующем изменении
				</>
			)}
		</div>
	);
};
